export default __webpack_public_path__ + "static/media/lift-install.a067f3fe.jpg";